// Main client
export { LegacyChainClient } from './core/LegacyChainClient';

// Services
export { TimeCapsuleService } from './services/TimeCapsuleService';
export { PaymentService } from './services/PaymentService';
export { LegalDocumentService } from './services/LegalDocumentService';
export { AnalyticsService } from './services/AnalyticsService';
export { IPFSService } from './services/IPFSService';

// Utilities
export { CryptoService } from './utils/crypto';
export { Logger } from './utils/logger';

// Middleware
export { RateLimiter } from './middleware/rateLimiter';

// Types
export * from './types';

// Version
export const VERSION = '1.0.0'; 